<script>
export default {
  name: "LeButton"
}
</script>

<template>
  <div class="le-button">
    <template v-if="$slots.icon">
      <div class="le-button-icon">
        <slot name="icon"></slot>
      </div>
    </template>

    <slot></slot>
  </div>
</template>

<style lang="sass">
.le-button
  display: inline-flex
  cursor: pointer
  border-radius: var(--radius-lg, 10px)
  text-align: center
  background: rgba(255, 255, 255, 0.04)
  padding: var(--spacing-6, 6px) var(--spacing-10, 10px)
  gap: var(--spacing-2, 2px)
  color: rgba(255, 255, 255, 0.50)

  /* shadows/xs */
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.05)
  /* Caption L/Medium */
  font-family: Inter, serif
  font-size: 14px
  font-style: normal
  font-weight: 500
  line-height: 20px
  letter-spacing: -0.07px

  &.is-white-hl
    background: var(--background-button-secondary, #FFF)
    //backdrop-filter: blur(50px)
    color: var(--text-base-primary, #14151A)
    border: 1px solid var(--border-action-normal, #DEE0E3)

  &-icon
    margin-right: 10px

</style>